import {
    GET_GROUPS,
    GET_GROUPS_ERROR,
    GET_GROUPS_SUCCESS,
} from '../constants/groupAppsConstants';

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function groupsAppsReducer(state = initialState, action){

    switch (action.type) {
        case GET_GROUPS:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'APP GROUPS',
                'loadingMessage': 'THE GROUPS ARE BEING LOADED',
                'type': action.type
            });
        case GET_GROUPS_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action,
                'type': action.type
            });
        case GET_GROUPS_SUCCESS:
            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'groupsAppsData': action.data,
                'type': action.type
            });
        default:
            return state;
    }
};

export default groupsAppsReducer